import {
  CLEAN_M7, SET_M7_FAILED, SET_M7_REQUEST, SET_M7_SEGMENTS_SUCCESS
} from './types';

const initialState = {
  segments: [],
  loading: false,
  error: null
};

export default function m7(state = initialState, action) {
  switch (action.type) {
    case SET_M7_SEGMENTS_SUCCESS:
      return {
        ...state,
        segments: action.data,
        loading: false,
        error: null
      };
    case SET_M7_REQUEST:
      return {
        ...state,
        loading: true
      };
    case SET_M7_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case CLEAN_M7:
      return initialState;
    default:
      return state;
  }
}
